import { setCompanyLogoModal } from '../../../../../store/workspace/slice';
import { selectCompanyLogo } from '../../../../../store/workspace/selectors';
import { useDispatch, useSelector } from '../../../../../store/store';
import ImageCrop from '../../../../../containers/ImageCrop';
import { ResizeIcon } from '../../../../../assets/icons';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import { useState } from 'react';

/** Crop step the picked company logo goes through before it is uploaded. */
export default function UploadCompanyLogo() {
    const dispatch = useDispatch();
    const companyLogo = useSelector(selectCompanyLogo);
    const [croppedImage, setCroppedImage] = useState<string | null>(null);

    return (
        <Modal
            size='md'
            icon={<ResizeIcon />}
            title='Drag to reposition'
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setCompanyLogoModal(false))}
        >
            <span>Company logo</span>
            <ImageCrop
                imageSrc={companyLogo}
                croppedImage={croppedImage}
                setCroppedImage={setCroppedImage}
            />
        </Modal>
    );
};
